import { Link } from '@inertiajs/react'

interface Animation {
  id: number
  name: string
  description: string
}

interface Props {
  animations: Animation[]
}

export default function AnimationsIndex({ animations }: Props) {
  return (
    <div className="min-h-screen bg-tessan-green p-4 sm:p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-2xl sm:text-4xl font-bold text-white text-center mb-2 sm:mb-4">
          Test Animations - Badge
        </h1>
        <p className="text-tessan-cream text-center mb-6 sm:mb-8 text-sm sm:text-base px-2">
          Cliquez sur une animation pour la tester. Actualisez pour rejouer.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-4">
          {animations.map((animation) => (
            <Link
              key={animation.id}
              href={`/animations/${animation.id}`}
              className="group bg-white/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-6 border border-tessan-cream/30 hover:bg-tessan-cream/20 hover:border-tessan-yellow transition-all duration-300 active:scale-95 sm:hover:scale-105"
            >
              <div className="text-xl sm:text-3xl font-bold text-tessan-yellow mb-1 sm:mb-2">
                #{animation.id}
              </div>
              <h2 className="text-sm sm:text-xl font-semibold text-white mb-1 sm:mb-2 group-hover:text-tessan-cream line-clamp-1">
                {animation.name}
              </h2>
              <p className="text-tessan-cream/70 text-xs sm:text-sm line-clamp-2 hidden sm:block">
                {animation.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
